export var DocumentFormatApi;
(function (DocumentFormatApi) {
    DocumentFormatApi[DocumentFormatApi["PlainText"] = 1] = "PlainText";
    DocumentFormatApi[DocumentFormatApi["Rtf"] = 2] = "Rtf";
    DocumentFormatApi[DocumentFormatApi["Html"] = 3] = "Html";
    DocumentFormatApi[DocumentFormatApi["OpenXml"] = 4] = "OpenXml";
})(DocumentFormatApi || (DocumentFormatApi = {}));
